<template>
  <div>
    <div class="ml-2 mt-12 text-h5">お知らせ新規登録</div>
    <div class="ml-4 blue-grey--text">赤印のある項目は必須入力です</div>
    <alert :errors="errors" css_class="ma-1"></alert>
    <v-container style="max-width: 800px" v-show="view_status.editable">
      <v-row
        v-for="input in inputs"
        :key="input.key"
        no-gutters
        dense
        class="mb-2"
      >
        <v-col cols="4">
          <v-subheader class="title mr-2" style="height: 100%"
            >{{ input.title
            }}<v-icon class="ml-1 mb-3 red--text caption" v-if="input.required"
              >mdi-asterisk</v-icon
            ></v-subheader
          ></v-col
        >
        <v-col>
          <v-select
            v-if="input.key == 'category'"
            :items="categoryList"
            item-text="text"
            item-value="value"
            v-model="selectedCategory"
            class="fixed-width-500"
            dense
            hide-details
            return-object
            outlined
          ></v-select>
          <div v-if="input.key == 'category.fixed'" class="mt-2 mb-2 ml-3" no-data-text="分類が登録されていません">
            {{ selectedCategory.text }}
          </div>
          <v-container v-if="input.key == 'file'">
            <v-row
              class="text-center"
              @dragover.prevent
              @dragenter="onDragEnter"
              @dragleave="onDragLeave"
              @drop="onDrop"
              @change="handleFileChange"
            >
              <v-file-input
                v-model="files"
                color="primary"
                placeholder="ファイルを選択するかドラッグ＆ドロップしてください。"
                prepend-icon="mdi-paperclip"
                counter
                outlined
                :show-size="1000"
                :background-color="isDragging ? 'blue' : 'null'"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>{{ text }}</v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >+{{ files.length - 2 }} File(s)</span>
                </template>
              </v-file-input>
            </v-row>
          </v-container>
          <div v-if="input.key == 'file.fixed'" class="mt-2 mb-2 ml-3">
            {{ parentGroup.text }}
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container style="max-width: 800px">
      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn
            color="secondary"
            outlined
            class="ma-2"
            width="200"
            @click="cancel"
            >キャンセル</v-btn
          >
        </v-col>
        <v-col cols="6">
          <v-btn
            color="primary"
            class="ma-2"
            width="200"
            @click="register"
            :disabled="!view_status.editable"
            >登録</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Api from "@/logic/api/api.js";
import Validate from "@/logic/common/validate.js";
import Roles from "@/logic/common/roles.js";
import Alert from "../components/common/alert.vue";
import AlertBuilder from "../logic/common/alert-contents";
import { required, maxLength } from "vuelidate/lib/validators";
import valueMapper from "../logic/common/value-mapper";

export default {
  props: {
    value: File
  },
  components: {
    alert: Alert,
  },
  validations: {
    formData: {
      groupName: {
        required,
        maxLength: maxLength(64),
      },
    },
  },
  computed: {
    disableRegisterButton() {
      return Validate.hasError([this.$v.formData.groupName]);
    },
    groupNameErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.groupName,
        "グループ名",
        ["required", "maxLength"],
        !this.delayCheck
      );
    },
  },

  name: "DragAndDrop",
  
  data() {
    // URLから参照先を取得する
    const uid = this.$route.params.uid;
    const isCreate = uid == "create" ? true : false;
    console.log("uid =" + uid);
    console.log("isCreate =" + isCreate);
    console.log("data() file =");
    console.log(this.files);
    var reader = new FileReader();
    console.log(reader);
    // 画面に表示する項目
    const inputs = [];
    inputs.push({
      key: "category",
      title: "分類",
      required,
    });
    inputs.push({
      key: "file",
      title: "添付ファイル",
      required,
    });

    this.$nextTick(() => {
      this.loadData(uid);
    });
    return {
      view_status: {
        editable: false,
      },
      isCreate: isCreate,
      groupId: uid,
      permission: [],
      permissionRoles: Roles.groupToGroupRoles(),
      inputs: inputs,
      delayCheck: false,
      selectedCategory: {
        text: "",
        value: "",
      },
      categoryList: [],
      categoryData: [],
      formData: {
        category: "-",
      },
      updateData: {
        recordDate: "",
        permissionIds: [],
      },
      errors: [],
      reader: reader,
      file: null,
      files: [],
      isDragging: false,
      dragCount: 0,
    };
  },
  methods: {
    /**
     * 分類を取得、画面に表示する
     */
    loadData(uid) {
      console.log("uid =" + uid);
      var that = this;
      this.view_status.editable = false;
      this.$store.commit("setWaiting", true);
      this.$nextTick(() => {
        // 分類一覧を取得する
        const mapping = [];
        const process = [];

        mapping.push("category.list");
        process.push(
          Api.call("/admin/information/category", {})
        );
        // 必要なAPIを全て実行する
        Promise.all(process)
          .then((result) => {
            console.log("category list in information-edit.vue");
            console.log(result);
            this.$store.commit("setWaiting", false);
            var list = result[mapping.indexOf("category.list")].categorys;
            list.forEach(function(value) {
              let data = {text: value.category, value: value.record_id};
              console.log(data);
              that.categoryList.push(data);
            });
            this.categoryData = list;
            this.view_status.editable = true;
          })
          .catch((result) => {
            // エラーになったリクエストが一つでもあればここに入る
            this.$store.commit("setWaiting", false);
            const message = valueMapper
              .map({
                403: AlertBuilder.error("権限がありません"),
              })
              .getOrElse(result.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(result);
            } else {
              this.showMessage(message);
            }
          });
      });
    },
    /**
     * メッセージを初期化する
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * メッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
    /**
     * 登録データを作成する
     */
    sendBaseData() {
      var found = this.categoryData.find(e => e.category === this.selectedCategory.text);
      console.log("found.record_id = " + found.record_id);
      console.log("this.reader.result = " + this.reader.result);
      console.log("this.reader.result = " + this.reader.result);
      var typedArray = new Uint8Array(this.reader.result);
      console.log("typedArray = " + typedArray);
      return {
        category: found.record_id,
        file: typedArray,
      };
    },
    /**
     * 登録データを作成する
     */
    buildRegisterData() {
      return {
        ...this.sendBaseData(),
      };
    },
    /**
     * 更新データを作成する
     */
    buildUpdateData() {
      let result = {
        ...this.sendBaseData(),
        group_id: this.groupId,
        original_permission_ids: this.updateData.permissionIds.map((item) => {
          return {
            permission_id: item.permission_id,
          };
        }),
        update_date: this.updateData.recordDate,
      };
      result["permissions"] = this.$refs.permissionSelect[0]
        .getAllContents()
        .map((item) => {
          let result = {
            ...item.role.value,
            destination_id: item.name.value,
            type: "permission",
            is_update: item.meta.edit,
          };
          if (item.meta.permission_id) {
            result["permission_id"] = item.meta.permission_id;
          }
          return result;
        });
      return result;
    },
    /**
     * データを登録する
     */
    register() {
      this.delayCheck = true;
      this.clearMessage();
      console.log("register()");

      // 入力を検証する
      console.log("this.selectedCategory.text.length = " + this.selectedCategory.text.length);
      if (this.selectedCategory.text.length == 0) {
        this.showMessage(AlertBuilder.error("分類を選択してください"));
        return;
      }
      console.log("this.file in register = " + this.files);
      if (this.files == null) {
        this.showMessage(AlertBuilder.error("ファイルを選択してください"));
        return;
      }

      // リクエストパラメータを作成する
      let url = "/admin/information/create";

      let formData = new FormData();
      formData.append('category', this.selectedCategory.value);
      formData.append('file', this.files);

      // APIを実行する
      this.$store.commit("setWaiting", true);
      Api.callFormData(url, formData)
        .then(() => {
          this.$store.commit("setWaiting", false);
          this.$router.push("/information");
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          console.log(error);
          const message = valueMapper
            .map({
              401: AlertBuilder.invalid(),
              409: AlertBuilder.error("編集が競合しています"),
            })
            .getOrElse(error.status, AlertBuilder.error("更新に失敗しました"));
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    cancel() {
      this.$router.push("/information");
    },
    handleFileChange(e) {
      // Whenever the file changes, emit the 'input' event with the file data.
      console.log("handleFileChange");
      this.files = e.target.files[0];
      this.reader.readAsArrayBuffer(this.files);
      this.reader.onload = function(){
        console.log("読み込み完了");
      };
      this.$emit('input', this.files)
    },
    selectCategory(event) {
      console.log("event = " + event);
      this.selectedCategory = {
        text: event
      };
      console.log("this.selectedCategory.text = " + this.selectedCategory.text);
    },

    onDrop(e) {
      console.log("onDrop");
      e.preventDefault();
      e.stopPropagation();
      this.isDragging = false;
      const _files = e.dataTransfer.files;
      console.log("_files.length = " + _files.length);
      if (_files.length == 1) {
        this.files = [];
        for (const file in _files) {
          if (!isNaN(file)) {
              //filesはファイル以外のデータが入っており、ファイルの場合のみキー名が数字になるため
              this.files.push(_files[file]);
              console.log(file);
          }
        }
        console.log("this.files[0] = " + this.files);
        this.files = this.files[0]
        this.reader.readAsArrayBuffer(this.files);
        this.reader.onload = function(){
          console.log("読み込み完了");
        };
        this.$emit('input', this.files);
      }
    },
    
    onDragEnter(e) {
      console.log("onDragEnter");
      e.preventDefault();
      this.isDragging = true;
      this.dragCount++;
    },

    onDragLeave(e) {
      console.log("onDragLeave");
      e.preventDefault();
      this.dragCount--;
      if (this.dragCount <= 0) {
        this.isDragging = false;
      }
    },
    deleteFile() {
      console.log("deleteFile");
      this.files = [];
      console.log("this.file in deleteFile = " + this.files);
    }
  },
};
</script>

<style scoped>
.title {
  background-color: #999999;
  color: white;
}
</style>
